import styled, { css } from "styled-components";
import { Button as BaseButton } from "antd";

import color from "../_style/color";

const buttonTheme = {
  primary: css`
    background-color: ${color.primary};
    border: 1px solid ${color.primary};
    color: ${color.light};
  `,
  "outline-primary": css`
    border: 1px solid ${color.primary};
    color: ${color.primary};
  `,
  secondary: css`
    background-color: ${color.sunsetOrange};
    border: 1px solid ${color.sunsetOrange};
    color: ${color.light};
  `,
  trading: css`
    background-color: ${color.trading};
    border: 1px solid ${color.trading};
    color: ${color.light};
  `,
  default: css`
    background-color: ${color.light};
    border: 1px solid ${color.gainsboro};
    color: inherit;
  `,
  borderless: css`
    background-color: ${color.light};
    border: unset;
    color: inherit;
  `,
};

const Button = styled(BaseButton).attrs((props) => ({
  type: props.type || "default",
  margin: props.margin || "unset",
  isHoverable: props.isHoverable || false,
}))`
  border-radius: 2px;
  margin: ${({ margin }) => margin};

  ${({ type }) => buttonTheme[type]};

  :focus,
  :hover {
    ${({ type }) => buttonTheme[type]}
  }

  [disabled] {
    color: ${color.light} !important;
    background-color: ${color.midgray} !important;
  }

  [ant-click-animating-without-extra-node="true"]::after,
  .ant-click-animation-node {
    --antd-wave-shadow-color: unset;
  }

  ${({ isHoverable }) =>
    isHoverable &&
    css`
      :hover {
        transition: 0.2s ease-in;
        cursor: pointer;
        background-color: ${color.primary};
        color: ${color.light};
        border: 1px solid ${color.gainsboro};
      }
    `}
`;

export default Button;
